import { Controller } from "@hotwired/stimulus"
import { cable } from "@hotwired/turbo-rails"

// Mounted once per page (on <body>, via both authenticated layouts). Opens a
// PresenceChannel subscription — reusing Turbo's own cable connection rather
// than a second websocket — and pings it every 30s while the tab is visible,
// so User#last_seen_at stays fresh for as long as any tab is open.
const PING_INTERVAL_MS = 30_000

export default class extends Controller {
  async connect() {
    const consumer = await cable.getConsumer()
    this.subscription = consumer.subscriptions.create({ channel: "PresenceChannel" })

    this.onVisible = this.onVisible.bind(this)
    document.addEventListener("visibilitychange", this.onVisible)
    this.interval = setInterval(this.onVisible, PING_INTERVAL_MS)
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.onVisible)
    clearInterval(this.interval)
    this.subscription?.unsubscribe()
  }

  onVisible() {
    if (document.visibilityState === "visible") this.subscription?.perform("ping")
  }
}
